<div class="container">
  <div class="form-signin">
    <div>
      <h2 class="form-signin-heading">Set Password</h2>
      <span class="form-text sub-title">{{ fullName }} enter your new password</span>
    </div>
    <form (ngSubmit)="changePass()" #changePassForm="ngForm">
      <div class="mb-3">
        <label for="newPassword" class="sr-only">New Password</label>
        <input type="password" class="form-control" [(ngModel)]="newPassword" placeholder="New password"
          minlength="settings.minPasswordLength" #newPasswordCtrl="ngModel" name="newPasswordCtrl"
          appPasswordValidator="newPasswordCtrl" id="newPasswordCtrl" />
        @if (!newPassword && newPasswordCtrl.touched) {
        <small class="form-text text-danger"> Password is required! </small>
        }
        @if (newPassword && newPasswordCtrl.touched && newPassword.length < settings.minPasswordLength) { <small
          class="form-text text-danger"> Password length must be at least {{ settings.minPasswordLength }}
          characters<br /> </small>
          }
          @if (newPassword && newPasswordCtrl.touched && newPasswordCtrl.errors?.invalidPassword) {
          <small class="form-text text-danger"> Password must have lowercase, uppercase, and special characters </small>
          }
      </div>
      <div>
        <label for="confirm-password" class="sr-only">New Password Again</label>

        <input type="password" class="form-control" [(ngModel)]="confirmPassword" minlength="settings.minPasswordLength"
          placeholder="Confirmation password" name="confirm-password" #confirmPasswordCtrl="ngModel"
          id="confirm-password" />
        @if (newPassword && confirmPasswordCtrl.touched && newPassword !== confirmPassword) {
        <small class="form-text text-danger"> Password is not confirmed! </small>
        }
      </div>
      <button
        [disabled]="!(newPassword && confirmPassword && newPassword === confirmPassword && !newPasswordCtrl.errors?.invalidPassword)"
        class="btn btn-lg btn-primary btn-block">
        Set Password
      </button>
    </form>

    <div>
      <small class="form-text">
        Already have an account?
        <a routerLink="../login">
          <strong>Sign In</strong>
        </a>
      </small>
    </div>
  </div>
</div>